/* eslint-disable func-names, max-len */
require.ensure(['videojs-core', 'videojs-youtube'], () => {
  require('videojs-core');
  require('videojs-youtube');

  require.ensure(['scrollmagic-core', 'scrollmagic-gsap', 'waypoints-core'], () => {
    const ScrollMagic = require('scrollmagic-core');
    require('scrollmagic-gsap');

    // SCROLL MAGIC
    // init controller
    const controller = new ScrollMagic.Controller();

    if ($('.js-item-grid-0').length) {
      new ScrollMagic
      .Scene({
        triggerElement: '.js-item-grid-0',
      })
      .addTo(controller)
      .setClassToggle('.js-item-grid-0', 'is-active');
    }

    if ($('.js-item-grid-1').length) {
      new ScrollMagic
      .Scene({
        triggerElement: '.js-item-grid-1',
      })
      .addTo(controller)
      .setClassToggle('.js-item-grid-1', 'is-active');
    }

    if ($('.js-item-grid-2').length) {
      new ScrollMagic
      .Scene({
        triggerElement: '.js-item-grid-2',
      })
      .addTo(controller)
      .setClassToggle('.js-item-grid-2', 'is-active');
    }

    if ($('.js-item-grid-3').length) {
      new ScrollMagic
      .Scene({
        triggerElement: '.js-item-grid-3',
      })
      .addTo(controller)
      .setClassToggle('.js-item-grid-3', 'is-active');
    }

    if ($('.js-item-grid-4').length) {
      new ScrollMagic
      .Scene({
        triggerElement: '.js-item-grid-4',
      })
      .addTo(controller)
      .setClassToggle('.js-item-grid-4', 'is-active');
    }
    if ($('.js-item-grid-5').length) {
      new ScrollMagic
      .Scene({
        triggerElement: '.js-item-grid-5',
      })
      .addTo(controller)
      .setClassToggle('.js-item-grid-5', 'is-active');
    }
    if ($('.js-item-grid-6').length) {
      new ScrollMagic
      .Scene({
        triggerElement: '.js-item-grid-6',
      })
      .addTo(controller)
      .setClassToggle('.js-item-grid-6', 'is-active');
    }
    if ($('.js-item-grid-7').length) {
      new ScrollMagic
      .Scene({
        triggerElement: '.js-item-grid-7',
      })
      .addTo(controller)
      .setClassToggle('.js-item-grid-7', 'is-active');
    }

    if ($('.js-item-grid-static').length) {
      new ScrollMagic
      .Scene({
        triggerElement: '.js-item-grid-static',
      })
      .addTo(controller)
      .setClassToggle('.js-item-grid-static', 'is-active');
    }
  });
});
